import { AvailableCarriers } from '../domain/enums/available-carriers.js';

class MultigatewayHandler {
  constructor(hasCustomGateway, gatewaysForOffer, gatewaysFromParams) {
    this.hasCustomGateway = hasCustomGateway;
    this.gatewaysForOffer = gatewaysForOffer;
    this.gatewaysFromParams = gatewaysFromParams;
  }
  execute() {
    if (this.hasCustomGateway) {
      return this.getGatewayResult(this.gatewaysForOffer);
    } else {
      return this.getGatewayResult(this.gatewaysFromParams.defaultGateways);
    }
  }
  getGatewayResult(gateways) {
    if (gateways.length > 1) {
      return AvailableCarriers.MULTI;
    } else {
      return gateways[0];
    }
  }
}

export { MultigatewayHandler };
